import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import { Btn, Inp, Sel, Row, SHead, Txta, SavedBadge } from './ui';
import { matchesVendorNameOnly, firstWordShortName } from '../utils';
import { dualWriteVendorRow, dualDeleteVendorRow } from '../lib/vendorDualWrite';

export default function VendorDirectory(p){
  var blank={id:null,name:"",shortName:"",contact:"",email:"",phone:"",website:"",notes:"",address:"",address2:"",city:"",state:"",zip:"",shipAttn:"",vendorType:"Vendor",resaleCertOnFile:false,resaleCertDate:"",contacts:[],aliases:[]};
  var es=useState(null);var editing=es[0];var setEditing=es[1];
  var fs=useState(blank);var form=fs[0];var setForm=fs[1];
  // Tracks whether the user has manually edited the short_name field on
  // the current form. When false (default for new-vendor flow), typing
  // into Vendor Name auto-populates shortName via firstWordShortName.
  // Once the user touches shortName directly, auto-population stops.
  var sts=useState(false);var shortNameTouched=sts[0];var setShortNameTouched=sts[1];
  var ss=useState("");var search=ss[0];var setSearch=ss[1];

  function set(k){return function(v){setForm(function(prev){var n=Object.assign({},prev);n[k]=v;return n;});};}

  // Name setter — also auto-populates shortName via firstWordShortName
  // when the user hasn't touched the shortName field on this form. Keeps
  // new-vendor entry frictionless (typing "Casa Design, LLC" fills "Casa")
  // while preserving any manual override the user has already entered.
  function setName(v){
    setForm(function(prev){
      var n=Object.assign({},prev,{name:v});
      if(!shortNameTouched) n.shortName=firstWordShortName(v);
      return n;
    });
  }
  function setShortName(v){
    setShortNameTouched(true);
    setForm(function(prev){return Object.assign({},prev,{shortName:v});});
  }

  // Name-only vendor filter — see matchesVendorNameOnly in utils.js.
  // Searches just vendor.name with three-pass normalization (raw /
  // collapsed-punctuation / squashed-whitespace) so "O" / "OG" /
  // "O+G" / "O and G" / "og studios" all match "O+G Studios". Multi-
  // field substring (matchesVendorSearch in utils.js) is retained for
  // possible future admin/reporting use but not wired here — name-only
  // is the right scope for a directory.
  var filtered=p.vendors.filter(function(v){return matchesVendorNameOnly(v,search);});

  function save(){
    if(!form.name.trim())return;
    var newVendor=form.id?Object.assign({},form):Object.assign({},form,{id:Date.now()});
    p.setVendors(form.id?p.vendors.map(function(v){return v.id===form.id?newVendor:v;}):[].concat(p.vendors,[newVendor]));
    dualWriteVendorRow(newVendor);
    closeModal();
  }

  function closeModal(){setEditing(null);setForm(blank);setShortNameTouched(false);}

  function del(id){
    if(!window.confirm("Remove this vendor?")) return;
    p.setVendors(p.vendors.filter(function(v){return v.id!==id;}));
    dualDeleteVendorRow(id);
  }

  var CERT_ENDPOINTS={
    CA:'/api/resale-cert',
    ID:'/api/resale-cert-idaho',
    FL:'/api/resale-cert-florida',
    CO:'/api/resale-cert-colorado',
    WY:'/api/resale-cert-wyoming',
  };
  var CERT_LABELS={CA:'CA CDTFA-230',ID:'ID ST-101',FL:'FL DR-13',CO:'CO DR 0563',WY:'WY SST F0003'};

  function generateResaleCertState(vendor,state){
    var firmSettings=p.firmSettings||{};
    var firmName=firmSettings.name||'Cimon Starr LLC';
    var firmCity=firmSettings.city||'San Francisco';
    var firmState=firmSettings.state||'CA';
    var firmZip=firmSettings.zip||'94118';
    var firmAddr=(firmSettings.address||'3516 Sacramento St.')+', '+firmCity+', '+firmState+' '+firmZip;
    var sellerPermit=firmSettings.sellerPermit||'225-379680';
    var principalName=firmSettings.principalName||'Cimon Starr';
    var principalTitle=firmSettings.principalTitle||'Principal';
    var phone=firmSettings.phone||'415-520-9020';
    var phoneParts=phone.replace(/[^0-9]/g,'');
    var phoneArea=phoneParts.length>=10?phoneParts.slice(0,3):'415';
    var phoneNumber=phoneParts.length>=10?phoneParts.slice(3,6)+'-'+phoneParts.slice(6,10):'520-9020';

    var payload={
      vendorName:vendor.name,
      vendorAddress:vendor.address||'',
      vendorCity:vendor.city||'',
      vendorState:vendor.state||'',
      vendorZip:vendor.zip||'',
      firmName:firmName,
      firmAddress:firmAddr,
      sellerPermit:sellerPermit,
      firmEin:firmSettings.ein||'39-4485769',
      principalName:principalName,
      principalTitle:principalTitle,
      phoneArea:phoneArea,
      phoneNumber:phoneNumber,
      // Florida DR-13 Annual Resale Certificate number. Distinct from
      // California seller's permit. Endpoint also falls back to the firm's
      // existing FL cert number if not set in firmSettings.
      flResaleCertNumber:firmSettings.flResaleCertNumber||'78-8019991063-1',
    };

    var endpoint=CERT_ENDPOINTS[state]||'/api/resale-cert';
    fetch(endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)})
      .then(function(r){if(!r.ok)throw new Error('API error '+r.status);return r.blob();})
      .then(function(blob){
        var url=URL.createObjectURL(blob);
        var a=document.createElement('a');
        a.href=url;
        a.download='ResaleCert_'+state+'_'+vendor.name.replace(/[^a-zA-Z0-9]/g,'_')+'.pdf';
        a.click();
        URL.revokeObjectURL(url);
        var certed=null;
        p.setVendors(p.vendors.map(function(v){
          if(v.id!==vendor.id) return v;
          certed=Object.assign({},v,{resaleCertOnFile:true,resaleCertDate:new Date().toLocaleDateString()});
          return certed;
        }));
        if(certed) dualWriteVendorRow(certed);
      })
      .catch(function(e){alert('Could not generate '+state+' resale cert: '+e.message);});
  }

  // Subtle delete button — light grey border, neutral × icon, no fill until hover
  var delBtn={
    width:24,height:24,padding:0,
    border:"0.5px solid #E0E0DC",borderRadius:4,
    background:"#FFFFFF",color:"#999",
    cursor:"pointer",fontSize:11,fontFamily:"inherit",
    display:"inline-flex",alignItems:"center",justifyContent:"center",
  };

  var tableRows=filtered.map(function(v){
    var typeLabel=v.vendorType||"Vendor";
    return (
      <tr key={v.id} style={{borderBottom:"1px solid #f0f0f0",cursor:"pointer"}}
        onClick={function(){
          setForm(Object.assign({},v,{contacts:v.contacts||[],shortName:v.shortName||""}));
          setShortNameTouched(!!(v.shortName&&String(v.shortName).trim()));
          setEditing(v.id);
        }}
        onMouseEnter={function(e){e.currentTarget.style.background="#FAFAF8";}}
        onMouseLeave={function(e){e.currentTarget.style.background="#FFFFFF";}}>
        <td style={{padding:"8px 10px",fontWeight:600}}>
          <div>{v.name}</div>
          {v.shortName?<div style={{fontSize:10,color:"#999",fontWeight:400,marginTop:2}}>{v.shortName}</div>:null}
        </td>
        <td style={{padding:"8px 10px"}}>
          {typeLabel==="Workroom"
            ? <span style={{background:"#ede7f6",color:"#6a1b9a",borderRadius:4,padding:"2px 7px",fontSize:11,fontWeight:700}}>Workroom</span>
            : typeLabel==="Receiver"
            ? <span style={{background:"#e8f5e9",color:"#2e7d32",borderRadius:4,padding:"2px 7px",fontSize:11,fontWeight:700}}>Receiver</span>
            : <span style={{background:"#e3f2fd",color:"#0277bd",borderRadius:4,padding:"2px 7px",fontSize:11,fontWeight:700}}>Vendor</span>
          }
        </td>
        <td style={{padding:"8px 10px",color:"#444"}}>
          {(v.contacts&&v.contacts.length>0)?v.contacts.map(function(c,i){return <div key={i}>{c.name||"—"}</div>;}):v.contact||"—"}
        </td>
        <td style={{padding:"8px 10px",color:"#444"}}>
          {(v.contacts&&v.contacts.length>0)?v.contacts.map(function(c,i){return <div key={i}>{c.email||"—"}</div>;}):v.email||"—"}
        </td>
        <td style={{padding:"8px 10px",color:"#444"}}>
          {(v.contacts&&v.contacts.length>0)?v.contacts.map(function(c,i){return <div key={i}>{c.phone||"—"}</div>;}):v.phone||"—"}
        </td>
        <td style={{padding:"8px 10px",color:"#777",maxWidth:240}}>{v.notes||"—"}</td>
        <td style={{padding:"8px 10px",width:40}}>
          <button
            onClick={function(e){e.stopPropagation();del(v.id);}}
            onMouseEnter={function(e){e.currentTarget.style.background="#F5F5F3";e.currentTarget.style.color="#666";}}
            onMouseLeave={function(e){e.currentTarget.style.background="#FFFFFF";e.currentTarget.style.color="#999";}}
            style={delBtn}
            title="Remove vendor">×</button>
        </td>
      </tr>
    );
  });

  var emptyRow=filtered.length===0?(
    <tr><td colSpan={7} style={{padding:20,textAlign:"center",color:"#bbb"}}>No vendors yet</td></tr>
  ):null;

  // ── Edit / new modal ──
  var modal=editing?(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}
      onClick={function(e){if(e.target===e.currentTarget)closeModal();}}>
      <div style={{width:720,maxWidth:"94vw",maxHeight:"92vh",background:"#fff",borderRadius:10,padding:24,overflowY:"auto",boxShadow:"0 8px 40px rgba(0,0,0,0.3)"}}>
        <div style={{display:"flex",alignItems:"baseline",marginBottom:16}}>
          <div style={{fontSize:16,fontWeight:600,color:"#111"}}>{editing==="new"?"New Vendor":"Edit Vendor"}</div>
          <div style={{flex:1}} />
          <button onClick={closeModal} style={{background:"none",border:"none",fontSize:22,color:"#999",cursor:"pointer",lineHeight:1,padding:0}}>×</button>
        </div>

        <Row>
          <div style={{flex:2}}><Inp label="Vendor Name" value={form.name} onChange={setName} required={true} /></div>
          <div style={{flex:1}}>
            <Inp label="Short Name" value={form.shortName||""} onChange={setShortName} placeholder="e.g. Casa" />
          </div>
          <div style={{flex:1}}>
            <Sel label="Vendor Type" value={form.vendorType||"Vendor"} onChange={set("vendorType")}>
              <option value="Vendor">Vendor (goods/products)</option>
              <option value="Workroom">Workroom (fabrication/labor)</option>
              <option value="Receiver">Receiver (freight / white glove delivery)</option>
            </Sel>
          </div>
        </Row>

        {/* The installs_own_goods toggle was removed 2026-06-03. The
            vendor-level flag was the wrong abstraction — installation is
            a property of the item, not the vendor. Per-item installation
            fee (item.fees.installation > 0) is now the source of truth
            for whether installation rides on the vendor PO. DB column
            remains as deprecated; mapper round-trips preserve value
            until column is dropped. */}

        {/* Top-level Contact / Email / Phone — represent the vendor's
            primary point of contact. Vendors added via VendorPicker's
            add modal populate these fields; without these inputs they
            were unreachable from VendorDirectory's edit modal (the
            Contacts repeater below is for ADDITIONAL contacts, a
            different field path). The table column at line ~190 falls
            back to v.email when v.contacts is empty, which is why the
            data path matters: writing a contact row does NOT update
            the top-level email. */}
        <Row>
          <div style={{flex:1}}><Inp label="Contact" value={form.contact||""} onChange={set("contact")} placeholder="Primary contact name" /></div>
          <div style={{flex:2}}><Inp label="Email" value={form.email||""} onChange={set("email")} placeholder="contact@vendor.com" /></div>
          <div style={{flex:1}}><Inp label="Phone" value={form.phone||""} onChange={set("phone")} placeholder="(415) 555-0000" /></div>
        </Row>

        <SHead>Additional Contacts</SHead>
        <div style={{marginBottom:16}}>
          {(form.contacts||[]).length===0&&<div style={{fontSize:11,color:"#bbb",marginBottom:8}}>No contacts yet — add below</div>}
          {(form.contacts||[]).map(function(c,i){
            return (
              <div key={i} style={{display:"grid",gridTemplateColumns:"1fr 1.4fr 1fr auto",gap:8,marginBottom:8,alignItems:"end"}}>
                <div>
                  {i===0&&<div style={{fontSize:10,color:"#888",marginBottom:2}}>Name</div>}
                  <input value={c.name||""} onChange={function(e){var cs=(form.contacts||[]).slice();cs[i]=Object.assign({},cs[i],{name:e.target.value});setForm(function(prev){return Object.assign({},prev,{contacts:cs});});}} placeholder="First Last" style={{width:"100%",padding:"7px 10px",border:"1px solid #ddd",borderRadius:5,fontSize:13,boxSizing:"border-box"}} />
                </div>
                <div>
                  {i===0&&<div style={{fontSize:10,color:"#888",marginBottom:2}}>Email</div>}
                  <input value={c.email||""} onChange={function(e){var cs=(form.contacts||[]).slice();cs[i]=Object.assign({},cs[i],{email:e.target.value});setForm(function(prev){return Object.assign({},prev,{contacts:cs});});}} placeholder="email@vendor.com" style={{width:"100%",padding:"7px 10px",border:"1px solid #ddd",borderRadius:5,fontSize:13,boxSizing:"border-box"}} />
                </div>
                <div>
                  {i===0&&<div style={{fontSize:10,color:"#888",marginBottom:2}}>Phone</div>}
                  <input value={c.phone||""} onChange={function(e){var cs=(form.contacts||[]).slice();cs[i]=Object.assign({},cs[i],{phone:e.target.value});setForm(function(prev){return Object.assign({},prev,{contacts:cs});});}} placeholder="(415) 000-0000" style={{width:"100%",padding:"7px 10px",border:"1px solid #ddd",borderRadius:5,fontSize:13,boxSizing:"border-box"}} />
                </div>
                <div>
                  {i===0&&<div style={{fontSize:10,color:"transparent",marginBottom:2}}>x</div>}
                  <button onClick={function(){var cs=(form.contacts||[]).filter(function(_,j){return j!==i;});setForm(function(prev){return Object.assign({},prev,{contacts:cs});});}} style={Object.assign({},delBtn,{width:30,height:30})}>×</button>
                </div>
              </div>
            );
          })}
          <button onClick={function(){setForm(function(prev){return Object.assign({},prev,{contacts:(prev.contacts||[]).concat([{name:"",email:"",phone:""}])});});}} style={{padding:"6px 14px",background:"#f5f5f5",border:"1px dashed #ddd",borderRadius:5,fontSize:11,cursor:"pointer",color:"#555",marginTop:4}}>+ Add Contact</button>
        </div>

        <Inp label="Website" value={form.website} onChange={set("website")} />

        <SHead>Shipping / Mailing Address</SHead>
        <Row>
          <div style={{flex:1}}><Inp label="Attn" value={form.shipAttn||""} onChange={set("shipAttn")} placeholder="Contact name for mail" /></div>
        </Row>
        <Row>
          <div style={{flex:2}}><Inp label="Address" value={form.address||""} onChange={set("address")} /></div>
          <div style={{flex:1}}><Inp label="Address Line 2" value={form.address2||""} onChange={set("address2")} /></div>
        </Row>
        <Row>
          <div style={{flex:2}}><Inp label="City" value={form.city||""} onChange={set("city")} /></div>
          <div style={{flex:1}}><Inp label="State" value={form.state||""} onChange={set("state")} /></div>
          <div style={{flex:1}}><Inp label="Zip" value={form.zip||""} onChange={set("zip")} /></div>
        </Row>

        <Txta label="Notes / Specialty" value={form.notes} onChange={set("notes")} rows={2} />

        {/* Aliases — alternate names this vendor appears under on receipts,
            invoices, OCR output, etc. Used by resolveVendorByName (utils.js)
            to auto-match incoming receipts. Auto-populated when the receipt
            VendorPicker re-snaps a mismatched OCR name to this vendor; can
            also be edited manually here.
            2026-06-28: removed the `form.id &&` gate so aliases can be
            added at vendor-creation time. The prior comment claimed aliases
            needed a SQL row to attach to, but they live on the vendor
            record itself (vendors.aliases text[]) — the save() flow
            writes the whole vendor row including aliases, so there's no
            reason to gate the editor. */}
        {true&&(
          <div style={{marginTop:16,paddingTop:16,borderTop:"1px solid #eee"}}>
            <SHead>Also Known As</SHead>
            <div style={{fontSize:11,color:"#888",marginBottom:8,fontStyle:"italic"}}>
              Other names this vendor shows up as on receipts and invoices. When a receipt comes in with a name on this list, it auto-matches to this vendor.
            </div>
            <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:8}}>
              {(form.aliases||[]).length===0&&<div style={{fontSize:11,color:"#bbb"}}>No aliases yet. Add below or they'll be added automatically when receipts come in.</div>}
              {(form.aliases||[]).map(function(a,i){
                return (
                  <div key={i} style={{display:"inline-flex",alignItems:"center",gap:4,padding:"4px 8px",background:"#F7F7F5",border:"0.5px solid #D8D7D2",borderRadius:11,fontSize:11,color:"#111"}}>
                    <span>{a}</span>
                    <button
                      onClick={function(){
                        var next=(form.aliases||[]).filter(function(_,j){return j!==i;});
                        setForm(function(prev){return Object.assign({},prev,{aliases:next});});
                      }}
                      style={{background:"none",border:"none",cursor:"pointer",fontSize:13,color:"#888",lineHeight:1,padding:0,marginLeft:2}}
                      title="Remove alias">×</button>
                  </div>
                );
              })}
            </div>
            <AddAliasInput onAdd={function(value){
              var trimmed=String(value||'').trim();
              if(!trimmed) return;
              var existing=(form.aliases||[]);
              // Skip duplicates (case-insensitive) and the primary name.
              var lc=trimmed.toLowerCase();
              if(lc===String(form.name||'').toLowerCase()) return;
              if(existing.some(function(a){return String(a).toLowerCase()===lc;})) return;
              setForm(function(prev){return Object.assign({},prev,{aliases:existing.concat([trimmed])});});
            }}/>
          </div>
        )}

        {form.id&&(
          <div style={{marginTop:16,paddingTop:16,borderTop:"1px solid #eee"}}>
            <SHead>Resale Certificates</SHead>
            <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
              {Object.keys(CERT_LABELS).map(function(state){
                return (
                  <Btn key={state} variant="secondary" onClick={function(){var v=p.vendors.find(function(vv){return vv.id===form.id;});if(v)generateResaleCertState(v,state);}}>
                    {CERT_LABELS[state]}
                  </Btn>
                );
              })}
            </div>
            {form.resaleCertOnFile&&<div style={{fontSize:11,color:"#2e7d32",marginTop:6}}>✓ Cert generated {form.resaleCertDate}</div>}
          </div>
        )}

        <div style={{display:"flex",gap:8,flexWrap:"wrap",marginTop:20,paddingTop:16,borderTop:"1px solid #eee"}}>
          <Btn onClick={save} disabled={!form.name.trim()}>Save Vendor</Btn>
          <Btn variant="secondary" onClick={function(){closeModal();}}>Cancel</Btn>
        </div>
      </div>
    </div>
  ):null;

  return (
    <div>
      <div style={{display:"flex",gap:10,marginBottom:14,alignItems:"center"}}>
        <input value={search} onChange={function(e){setSearch(e.target.value);}} placeholder="Search vendors..." autoCorrect="off" autoCapitalize="none" spellCheck={false} autoComplete="off" style={{flex:1,maxWidth:420,padding:"7px 10px",border:"1px solid #ddd",borderRadius:6,fontSize:12}} />
        <Btn onClick={function(){setForm(blank);setShortNameTouched(false);setEditing("new");}}>+ Add Vendor</Btn>
        <SavedBadge on={p.saved} />
      </div>
      <div style={{border:"1px solid #e0e0e0",borderRadius:8,overflow:"hidden"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead>
            <tr style={{background:"#f5f5f5"}}>
              {["Vendor","Type","Contact","Email","Phone","Notes",""].map(function(hd){
                return <th key={hd} style={{padding:"8px 10px",textAlign:"left",fontWeight:600,color:"#555",borderBottom:"1px solid #e0e0e0"}}>{hd}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {emptyRow}
            {tableRows}
          </tbody>
        </table>
      </div>
      {modal}
    </div>
  );
}

// Inline alias input — small text box + Add button. Calls onAdd with the
// trimmed value; parent dedupes against existing aliases + primary name.
// Enter key submits. Cleared on submit.
function AddAliasInput(p){
  var vs=useState(''); var v=vs[0]; var setV=vs[1];
  function submit(){ p.onAdd(v); setV(''); }
  return (
    <div style={{display:"flex",gap:6,alignItems:"center"}}>
      <input
        type="text"
        value={v}
        onChange={function(e){setV(e.target.value);}}
        onKeyDown={function(e){ if(e.key==='Enter'){ e.preventDefault(); submit(); } }}
        placeholder="e.g. SUSAN LIND CHASTAIN, INC."
        style={{flex:1,padding:"7px 10px",border:"1px solid #ddd",borderRadius:5,fontSize:12,boxSizing:"border-box"}}
      />
      <button
        onClick={submit}
        disabled={!v.trim()}
        style={{padding:"6px 12px",background:v.trim()?'#111':'#ccc',color:'#fff',border:'none',borderRadius:5,fontSize:11,cursor:v.trim()?'pointer':'default',whiteSpace:'nowrap'}}>
        + Add alias
      </button>
    </div>
  );
}
